import React, { useEffect, useState } from "react";

import { AirlineContext } from "./AirlineContext";
import { GetAirlineListResponse } from "../../../../../common/api/admin-api/GetAirlineListResponse";
import { useAdminAirlineApi } from "../../../common/api/useAdminAirlineApi";
import { AirlineListItem, mapToAirlineListItem } from "../AirlineListItem";

interface AirlineProviderProps {
    children: React.ReactNode;
}

export const AirlineProvider: React.FC<AirlineProviderProps> = (props: AirlineProviderProps) => {
    const { children } = props;
    const { getAirlineList } = useAdminAirlineApi();

    const [airlineItems, setAirlineItems] = useState<AirlineListItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getAirlineList().then((response: GetAirlineListResponse) => {
            const airlines = response.items.map(mapToAirlineListItem);
            setAirlineItems(airlines);
            setIsLoading(false);
        });
    }, []);

    return (
        <AirlineContext.Provider value={{ airlineItems, isLoading, setAirlineItems }}>
            {children}
        </AirlineContext.Provider>
    );
};
